module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_onboard_alternative-7b0532c8268b82c453ef7b772b4eb8db.svg";